import trendingUndergroundSagas from './lineups/sagas'

const sagas = () => [...trendingUndergroundSagas()]
export default sagas
